import { hoursLabel } from '../duration';
import { formatMoney } from '../money';

/** A visit's length in hours: "1.5 hrs". */
export const length = hoursLabel;

export const money = formatMoney;

/** Contractors see a customer by first name only. */
export const firstName = (name: string) => name.split(' ')[0] ?? name;
